"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var errorUtils_1 = require("spry-react/utils/errorUtils");
var knockoutBoundProperty_1 = require("spry-react/Knockout/knockoutBoundProperty");
var knockoutComponent_1 = require("spry-react/Knockout/knockoutComponent");
var labeled_1 = require("spry-react/Label/labeled");
var lockToggle_1 = require("spry-react/Label/lockToggle");
require("../Warnings/warning.less");
var DateTimePicker = /** @class */ (function (_super) {
    __extends(DateTimePicker, _super);
    function DateTimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.vm = {
            id: _this.props.id,
            value: ko.observable(_this.props.value),
            isRequired: ko.observable(_this.props.required),
            enable: ko.observable(!_this.props.disabled),
            pickDate: _this.props.pickDate == undefined ? ko.observable(true) : ko.observable(_this.props.pickDate),
            pickTime: _this.props.pickTime == undefined ? ko.observable(true) : ko.observable(_this.props.pickTime),
            defaultTime: _this.props.defaultTime,
            defaultViewDate: _this.props.defaultViewDate,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            enabledDates: _this.props.enabledDates,
            disabledDates: _this.props.disabledDates,
            format: _this.props.format,
            stepping: _this.props.stepping,
            title: ko.observable(_this.props.title),
            errors: ko.observable(_this.getErrorsFromProps(props)),
            className: ko.observable(_this.props.className)
        };
        _this.koBoundValue = new knockoutBoundProperty_1.KnockoutBoundProperty(_this.vm.value, _this.props.onChange);
        return _this;
    }
    DateTimePicker.prototype.getErrorsFromProps = function (props) {
        var errors = {};
        var output = errorUtils_1.toError(props.errorMessage);
        if (!output.isValid) {
            errors["error"] = output.title;
        }
        return errors;
    };
    DateTimePicker.prototype.componentWillReceiveProps = function (nextProps) {
        this.koBoundValue.onChange = nextProps.onChange;
        this.koBoundValue.update(nextProps.value);
        this.vm.isRequired(!!nextProps.required);
        this.vm.enable(!nextProps.disabled);
        this.vm.title(nextProps.title);
        this.vm.pickDate(nextProps.pickDate == undefined ? true : nextProps.pickDate);
        this.vm.pickTime(nextProps.pickTime == undefined ? true : nextProps.pickTime);
        if (this.props.errorMessage !== nextProps.errorMessage) {
            this.vm.errors(this.getErrorsFromProps(nextProps));
        }
        this.vm.className(nextProps.className || null);
    };
    DateTimePicker.prototype.componentWillUnmount = function () {
        this.koBoundValue.dispose();
    };
    DateTimePicker.prototype.shouldComponentUpdate = function () {
        return false;
    };
    DateTimePicker.prototype.render = function () {
        var content = React.createElement("div", { "data-bind": "component: { name: 'pb-date-time-picker', params: { value: value, id: id, isRequired: isRequired, enable: enable, pickDate: pickDate, pickTime: pickTime, minDate: minDate, maxDate: maxDate, enabledDates: enabledDates, disabledDates: disabledDates, defaultTime: defaultTime, defaultViewDate: defaultViewDate, format: format, stepping: stepping, title: title, matrixPropertyError: 'error', cssClasses: className } }" });
        var focus = this.props.autoFocus ? '.date-time-picker-input' : '';
        var output = errorUtils_1.toError(this.props.errorMessage);
        var classes = classNames({
            'input-validation-warning': !output.isValid && output.allWarnings,
            'full-input-warning': !output.isValid && output.allWarnings
        });
        return (React.createElement("div", { className: classes },
            React.createElement(knockoutComponent_1.KnockoutComponent, { content: content, vm: this.vm, focusElementSelector: focus })));
    };
    return DateTimePicker;
}(React.Component));
exports.DateTimePicker = DateTimePicker;
exports.LabeledDateTimePicker = labeled_1.labeled(DateTimePicker);
exports.LockToggleDateTimePicker = lockToggle_1.lockToggle(DateTimePicker);
